import { ReactNode, useCallback, useState } from "react";

import { SlideSideBar } from "../../atoms";
import {
  CollectPastDueInvoiceSidebarProviderContext,
  OpenCollectPastDueInvoiceSidebarOptions,
} from "./CollectPastDueInvoiceSidebarProviderContext";
import { CollectPastDueInvoiceForm } from "./components/CollectPastDueInvoiceForm/CollectPastDueInvoiceForm";

export type CollectPastDueInvoiceSidebarProviderProps = {
  children: ReactNode;
};

export const CollectPastDueInvoiceSidebarProvider = ({
  children,
}: CollectPastDueInvoiceSidebarProviderProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [sidebarState, setSidebarState] =
    useState<OpenCollectPastDueInvoiceSidebarOptions>({
      invoiceNumber: "",
      userMemberId: "",
    });

  const closeSidebar = useCallback(() => {
    setIsVisible(false);
  }, []);

  const openCollectPastDueInvoiceSidebar = useCallback(
    (options: OpenCollectPastDueInvoiceSidebarOptions) => {
      setSidebarState(options);
      setIsVisible(true);
    },
    [],
  );
  return (
    <CollectPastDueInvoiceSidebarProviderContext.Provider
      value={{ openCollectPastDueInvoiceSidebar }}
    >
      <SlideSideBar
        isOpen={isVisible}
        hide={() => closeSidebar()}
        className="!w-full lg:!w-1/2"
      >
        {isVisible && (
          <CollectPastDueInvoiceForm
            onClose={() => closeSidebar()}
            {...sidebarState}
          />
        )}
      </SlideSideBar>
      {children}
    </CollectPastDueInvoiceSidebarProviderContext.Provider>
  );
};
